// extracted by mini-css-extract-plugin
export var category = "ProductCard-module--category--09d92";
export var container = "ProductCard-module--container--b9034";
export var image = "ProductCard-module--image--28db3";
export var label = "ProductCard-module--label--1dc61";
export var labels = "ProductCard-module--labels--89710";
export var sku = "ProductCard-module--sku--5078f";
export var tag = "ProductCard-module--tag--38cf9";
export var tags = "ProductCard-module--tags--d1b9f";
export var textArea = "ProductCard-module--textArea--5405c";
export var title = "ProductCard-module--title--a748c";
export var wifi = "ProductCard-module--wifi--96d01";